<script lang="ts">
    // Bloco "Status": em vez de uma fileira de botões que quebra linha, mostra o status atual e,
    // ao tocar, abre a lista inteira com a explicação de cada um (o mesmo texto que o formulário
    // antigo exibia embaixo da fileira).
    import { createEventDispatcher, tick } from 'svelte'
    import { slide } from 'svelte/transition'
    import { AppointmentStatusFriendly, AppointmentStatusHelper } from '../../../../modules/schedulerApi/appointments/appointments.enum'
    import ZsheetSection from '../../../_common/z/sheet/zsheet-section.svelte'
    import ZsheetOptions from '../../../_common/z/sheet/zsheet-options.svelte'
    import type { ZsheetOption } from '../../../_common/z/sheet/zsheet'

    const dispatch = createEventDispatcher()

    export let value: string = null

    let open = false
    let listEl: HTMLElement = null

    // a lista tem 8 itens e o atual costuma ficar fora da tela ao abrir: traz ele para perto
    async function expand() {
        open = true
        await tick()
        listEl?.querySelector('.selected')?.scrollIntoView({ block: 'nearest' })
    }

    // "Faltou: cliente não compareceu..." → só a explicação, sem repetir o nome do status
    function description(key: string) {
        const text = AppointmentStatusHelper[key] || ''
        const cut = text.indexOf(': ')
        return cut > 0 ? text.slice(cut + 2) : text
    }

    const options: ZsheetOption[] = Object.keys(AppointmentStatusFriendly).map((key) => ({
        value: key,
        label: AppointmentStatusFriendly[key],
        description: description(key),
    }))

    $: current = options.find((el) => el.value === value)

    function onChange(ev) {
        value = ev.detail
        open = false
        dispatch('change', value)
    }
</script>

<ZsheetSection label="Status">
    {#if !open}
        <button type="button" class="current" on:click={expand}>
            <span class="current_text">
                <span class="current_label">{current?.label || 'Selecione'}</span>
                {#if current?.description}
                    <span class="current_desc">{current.description}</span>
                {/if}
            </span>
            <span class="current_act">Alterar</span>
        </button>
    {:else}
        <div transition:slide={{ duration: 160 }} bind:this={listEl}>
            <ZsheetOptions {options} {value} on:change={onChange} />
        </div>
    {/if}
</ZsheetSection>

<style>
    /* valores base = tema escuro */
    .current {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        text-align: left;
        padding: 9px 10px;
        border: 1px solid #2ecc7166;
        border-radius: 10px;
        background: #2ecc711f;
        color: inherit;
        font: inherit;
    }
    .current_text {
        flex: 1 1 auto;
        min-width: 0;
    }
    .current_label {
        display: block;
        font-size: 14.5px;
        font-weight: 600;
        line-height: 1.25;
    }
    .current_desc {
        display: block;
        font-size: 12.5px;
        opacity: 0.6;
        line-height: 1.3;
        margin-top: 1px;
    }
    .current_act {
        flex: 0 0 auto;
        font-size: 13px;
        opacity: 0.7;
        text-decoration: underline;
    }

    :global(.theme_light) .current {
        background: #2ecc7114;
    }
</style>
